import type { Theme } from '@mui/material';
import { tabClasses, tabsClasses } from '@mui/material';
// import type { Components } from '@mui/material/styles';

export const CUSTOM_ATTRIBUTE_SIZE = 'data-0';
export const CUSTOM_ATTRIBUTE_EQUAL_WIDTH = 'data-1';

export default function MUITabs(theme: Theme) /* : Components['MuiTabs'] */ {
  const colorList = Object.entries(theme.palette).filter(
    ([key, value]) => key !== 'neutral' && value?.main && value?.contrastText,
  );

  return {
    defaultProps: {
      variant: 'scrollable',
      scrollButtons: true,
    },
    styleOverrides: {
      root: {
        borderBottom: '1px solid',
        borderColor: theme.palette.divider,
        minHeight: 'auto',
        maxHeight: '100%',
      },
    },
    variants: [
      ...colorList.map(([key, value]) => ({
        props: { indicatorColor: key },
        style: {
          [`.${tabsClasses.indicator}`]: {
            backgroundColor: value?.main,
          },
        },
      })),
      {
        props: { [CUSTOM_ATTRIBUTE_SIZE]: 'small' },
        style: {
          [`& .${tabClasses.root}`]: {
            minHeight: '44px',
            minWidth: '44px',
            fontSize: 12,
            lineHeight: 1.66,

            [`& .${tabClasses.iconWrapper}`]: {
              fontSize: 16,
            },
          },
        },
      },
      {
        props: { [CUSTOM_ATTRIBUTE_EQUAL_WIDTH]: '' },
        style: {
          [`& .${tabsClasses.flexContainer}`]: {
            display: 'grid',
            gridTemplateColumns: 'repeat(var(--internal-children-count), 1fr)',

            [`& .${tabClasses.root}`]: {
              minWidth: 'max-content',
            },
          },
        },
      },
    ],
  };
}
